import { useAuth } from '../../contexts/AuthProvider';
import styles from './LoginPage.module.scss';

const FEATURES = [
    'Multi-currency portfolio tracking across India, USA & Canada',
    'Automated cross-border tax simulation & residency tracking',
    'FIRE planning with multi-jurisdiction projections',
];

const TRUST_BADGES = [
    { icon: '🔒', label: '256-bit encryption' },
    { icon: '🛡️', label: 'No data sharing' },
    { icon: '✓', label: 'GDPR compliant' },
];

export function LoginPage() {
    const { signIn, signUp } = useAuth();

    return (
        <div className={styles.page}>
            {/* ── Left: hero panel ── */}
            <div className={styles.hero}>
                <div className={styles.heroTop}>
                    <div className={styles.heroLogo}>
                        <svg width="36" height="36" viewBox="0 0 48 48" fill="none">
                            <circle cx="24" cy="24" r="20" stroke="currentColor" strokeWidth="3" />
                            <path d="M14 24h20M24 14v20" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
                        </svg>
                        <span className={styles.heroLogoText}>Expat Horizon</span>
                    </div>

                    <h1 className={styles.heroTitle}>Manage Global Wealth with Precision</h1>
                    <p className={styles.heroSubtitle}>
                        An institutional-grade command center for international professionals managing assets across
                        borders, currencies, and tax jurisdictions.
                    </p>

                    <ul className={styles.featureList}>
                        {FEATURES.map((f) => (
                            <li key={f} className={styles.featureItem}>
                                <span className={styles.featureCheck}>✓</span>
                                <span>{f}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <blockquote className={styles.testimonial}>
                    <p className={styles.testimonialText}>
                        "Finally, a platform that understands the complexity of managing wealth across three countries
                        simultaneously."
                    </p>
                    <footer className={styles.testimonialAuthor}>— NRI Professional, Managing Director</footer>
                </blockquote>
            </div>

            {/* ── Right: sign-in panel ── */}
            <div className={styles.panel}>
                <div className={styles.panelInner}>
                    <h2 className={styles.panelTitle}>Welcome Back</h2>
                    <p className={styles.panelSubtitle}>Sign in to access your global dashboard</p>

                    <div className={styles.actions}>
                        <button className={styles.cta} onClick={signIn}>
                            <span>Sign In to Horizon</span>
                            <span className={styles.ctaArrow}>→</span>
                        </button>
                        <div className={styles.divider}>
                            <span>New to Expat Horizon?</span>
                        </div>
                        <button className={styles.ctaSecondary} onClick={signUp}>
                            Create Account
                        </button>
                    </div>

                    <div className={styles.trustRow}>
                        {TRUST_BADGES.map((b) => (
                            <div key={b.label} className={styles.trustBadge}>
                                <span className={styles.trustIcon}>{b.icon}</span>
                                <span>{b.label}</span>
                            </div>
                        ))}
                    </div>

                    <p className={styles.privacy}>No bank linking required. Your data stays with you.</p>
                </div>
            </div>
        </div>
    );
}
